module.exports = __webpack_public_path__ + "img/menu.b8b11cdb.svg";